import _ from "lodash";
import { path } from "../../api";
import * as actions from "../../utils/actions";
import { restClient } from "../../utils/restClient";

const initialState = {
  transactionProfiles: [],
  transactionProfile: null,
};

export default {
  namespaced: true,
  name: "transactionProfiles",
  state: _.cloneDeep(initialState),
  mutations: {
    [actions.GET_TRANSACTION_PROFILES](state, payload = []) {
      state.transactionProfile = payload;
    },
    [actions.GET_TRANSACTION_PROFILE](state, payload = null) {
      state.transactionProfile = payload;
    },
    [actions.CREATE_TRANSACTION_PROFILE](state, payload = null) {
      state.transactionProfile = payload;
    },
    [actions.UPDATE_TRANSACTION_PROFILE](state, payload = null) {
      state.transactionProfile = payload;
    },
    [actions.RESET_TRANSACTION_PROFILE_FORM](state) {
      state.transactionProfile = null;
    },
  },
  actions: {
    async fetchTransactionProfiles({ commit }, payload = {}) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.transactionProfiles.base,
            "GET",
            null,
            payload
          );
          commit(actions.GET_TRANSACTION_PROFILES, response.data.data);
          resolve(response);
        } catch (error) {
          commit(actions.GET_TRANSACTION_PROFILES, []);
          reject(error);
        }
      });
    },
    async fetchTransactionProfile({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await restClient(
            path.admin.transactionProfiles.single(payload),
            "GET"
          );
          commit(actions.GET_TRANSACTION_PROFILE, data);
          resolve(data);
        } catch (error) {
          commit(actions.GET_TRANSACTION_PROFILE, null);
          reject(error);
        }
      });
    },
    async createTransactionProfile({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.transactionProfiles.base,
            "POST",
            payload
          );
          commit(actions.CREATE_TRANSACTION_PROFILE, response?.data);
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async updateTransactionProfile({ commit }, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.transactionProfiles.single(payload.id),
            "PUT",
            payload
          );
          commit(actions.UPDATE_TRANSACTION_PROFILE, response?.data);
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async deleteTransactionProfile(_, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.admin.transactionProfiles.single(payload),
            "DELETE"
          );
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    resetForm({ commit }) {
      commit(actions.RESET_TRANSACTION_PROFILE_FORM);
    },
  },
};
